































































/* eslint-disable */
import { Component, Vue, Watch } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import axios from "axios";
import { Token } from "../utils/Token";
import store from "@/store";



@Component({
  components: {
  },
  
})
export default class Login extends Vue {
  public hidePassword = true;
  public user = {
    username: null,
    password: null,
  };

  public usernameRules: any = [];
  public passwordRules: any = [];

  public errorModalFlag = false;
  public errorText = "";
  public errorTitle = "";
  public targets: Array<{
    id:number,
    label:string,
  }>=[];


  @Watch("user.firstName")
  usernameChanged() {
    this.usernameRules = [];
  }

  @Watch("user.lastName")
  passwordChanged() {
    this.passwordRules = [];
  }

  created() {
    console.log("cre login")
    EventBus.$off('closeErrorModal')
    EventBus.$on("closeErrorModal", (value: boolean) => {
      this.errorModalFlag = value;
    });

    //when accounts socket receives message, emits to this event to refresh users table
    EventBus.$on("eventLogs", (value: any) => {
     const message = value;
     console.log("mes: ",message);
     
     if (value.event==="Create") {
      let label="";
      this.targets.filter(el=>parseInt(value.id)===el.id? label=el.label:"") 
      const snackbarData = {
            text:"File Received. From "+label+ " with name "+ value.path.split("received/")[1],
            color: value.event === "Create" ? "#4caf50" : "#2196f3",
            };
      EventBus.$emit("showSnackbar", snackbarData);
    }   
    });

    EventBus.$on("refreshListing", () => {
      this.fetchTargets();
    });

    ////EventBus.$emit("FinishLoader",null );   

  }
 
  public submitHandler(): void {
    this.usernameRules = [(v: any) => !!v || "Username is required"];

    this.passwordRules = [(v: any) => !!v || "Password is required"];

    const self = this;
    setTimeout(function () {
      // In order for TypeScript to know which type is being used for form, we need to cast the value.
      const result = (
        self.$refs.form as Vue & {
          validate: () => boolean;
        }
      ).validate();
      console.log("result of validation:", result);
      if (result) {
        ////EventBus.$emit("BeginLoader",null );   

        axios.defaults.withCredentials = true;
        // successful front end validation, execute API call
        axios({
          method: "post",
          url: `${process.env.VUE_APP_BASE_URL}/login`,
          data: self.user,
        })
          .then((response) => {
            console.log("successful API response:", response);
            console.log("with code:", response.data.code);
            if (response.data.code == 401) {
              // The backend may send `error: null` for invalid credentials
              const error = response.data.error || {};
              self.errorText = error.message || "Invalid username or password.";
              self.errorTitle = error.title || "Login failed";
              self.errorModalFlag = true;
            } else if (response.data.code == 200) {
              Token.setTokenWithExpiry(
                "token",
                response.data.accessToken,
                +response.data.exp,
                response.data.type,
                response.data.refreshToken
              );
              const atype=response.data.type;

               //sockets connection
              self.fetchTargets()
              self.$store.dispatch('createSockets');
              if(atype!=0){
                self.$router.push({ name: "Files" });
              }else{
                self.$router.push({ name: "DeviceListing" });
              }
            }
            ////EventBus.$emit("FinishLoader",null );
          })
          .catch((err) => {
            ////EventBus.$emit("FinishLoader",null );
            console.log("failed API call:", err);
          });
      } 
    });
  }

  
  private  async fetchTargets() {
    const token =await Token.getTokenWithExpiry("token");
    ////EventBus.$emit("BeginLoader",null );   

    axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/targets`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        ////EventBus.$emit("FinishLoader",null );   

        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          if (response.data.code == 200) {
            this.targets = response.data.targets;
            console.log("targ ",this.targets)
          }
        }
      })
      .catch((err) => {
        ////EventBus.$emit("FinishLoader",null );
        console.log("error:", err);
      });
  }
}
